import type {
  SlotAvailability
} from './schedulingUtils'

// The one place the free/busy color contract lives — used by both the legend
// and the time list, so they can't drift apart.
export function AvailabilityDot({
  status,
  label
}: {
  status: SlotAvailability,
  label?: string
}): JSX.Element {
  return (
    <span
      className={`w-2 h-2 rounded-full shrink-0 ${
        status === 'busy' ? 'bg-red-500' : 'bg-green-600'
      }`}
      aria-label={label}
    />
  )
}
